// Customer.js
import React, { useState } from 'react';
import { HStack } from '@chakra-ui/react';
import { useColors } from '../../../../components/common/Color';
import LeftFormSection from './LeftFormSection';
import RightSection from '../Right/RightSection';
import HeaderSection from '../../../../components/common/Header/HeaderSection';
import CustomerContent from './List'; // Import the Customer component

function Customer() {
  const colors = useColors();
  const [isExpanded, setIsExpanded] = useState(false);

  // Toggle the expanded state
  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div>
      {/* Use the new HeaderSection component */}
      <HeaderSection
        title="Add Customer" 
        breadcrumb={["Dashboard", "Party", "Add Customer"]} 
      />

      <HStack align="start" w="full"  gap="0" mt={4}>
        <LeftFormSection colors={colors} />
        <RightSection 
          isExpanded={isExpanded} 
          toggleExpand={toggleExpand} 
          colors={colors} 
          content={CustomerContent} // Pass the Customer component
        />
      </HStack>
    </div>
  );
}

export default Customer;
